<div class="d-flex align-items-center">
  <div class="col-2 m-0 p-0 aboca-black-color">
    <a mat-icon-button
      (click)="back.emit()">
      <mat-icon>arrow_back_ios</mat-icon>
    </a>
  </div>
  <div class="col-20 text-center text-truncate title">{{title}}</div>
</div>